import swiper from "swiper";

var serviseNav1 = new swiper(".js-itocity-top-slider", {
 speed: 10000,
 slidesPerView: 'auto',
 spaceBetween: 0,
 centeredSlides: true,
 disableOnInteraction: false,
 // init: false,
 autoplay: {
   delay: 0,
   stopOnLastSlide: false,
   disableOnInteraction: false,
   reverseDirection: false
 },
 loop: true,
});

var serviseNav2 = new swiper(".js-itocity-bottom-slider", {
 speed: 10000,
 slidesPerView: 'auto',
 spaceBetween: 0,
 centeredSlides: true,
 disableOnInteraction: false,
 // init: false,
 autoplay: {
   delay: 0,
   stopOnLastSlide: false,
   disableOnInteraction: false,
   reverseDirection: false
 },
 loop: true,
});
